module.exports = __webpack_public_path__ + "img/GAME_NIGHTSKY2.03c12b0e.jpg";